<ng-content select="app-error-title"></ng-content>
<ng-content select="app-error-body"></ng-content>
<ng-content></ng-content>

<div class="error-actions">
  <button mat-button (click)="tryAgain.emit()" i18n>Try again</button>
</div>
